<div class="slider-container"
     (mousedown)="onMouseDown($event)"
     (mouseup)="onSlidingEnd()"
     (mousemove)="onMouseMove($event)"
     (mouseleave)="onMouseLeave()"
     (touchstart)="onTouchStart($event)"
     (touchend)="onSlidingEnd()"
     (touchmove)="onTouchMove($event)"
     (touchcancel)="onSlidingEnd()"
>
  <div class="slides-wrapper" [ngStyle]="{'transform': 'translateX(' + (translateX - getContainerWidth()) + 'px)', 'transition': transition}">
    <div
      *ngIf="!isMobile && allItems.length > 1"
      [style]="location.path() === '/services' ? 'width: 80px' : ''"
      (click)="moveRight()"
      class="click-zone click-zone-left"
    ></div>
    <div *ngIf="!isMobile && allItems.length > 1" (click)="moveLeft()" class="click-zone click-zone-right"></div>

    <div class="slide">
      <div class="slide-points" *ngIf="allItems.length > 1">
        <div *ngFor="let point of allItems; let i = index">
          <div class="point" [class.point-active]="i === prevIndex"></div>
        </div>
      </div>
      <ng-container *ngIf="slideType === 'locations'; else serviceSlidePrev">
        <app-title-background
          [portal]="true"
          [button]="showButton"
          [countdown]="getPercent()"
          [locationDto]="getCurrentItem(prevIndex)"
          (emitClick)="clickOn()"
        />
      </ng-container>
      <ng-template #serviceSlidePrev>
        <app-about-el
          [el]="getCurrentItem(prevIndex)"
        />
      </ng-template>
    </div>

    <div class="slide">
      <div class="slide-points" *ngIf="allItems.length > 1">
        <div *ngFor="let point of allItems; let i = index">
          <div class="point" [class.point-active]="i === currentIndex"></div>
        </div>
      </div>
      <ng-container *ngIf="slideType === 'locations'; else serviceSlideCurrent">
        <app-title-background
          [portal]="true"
          [button]="showButton"
          [countdown]="getPercent()"
          [locationDto]="getCurrentItem(currentIndex)"
          (emitClick)="clickOn()"
        />
      </ng-container>
      <ng-template #serviceSlideCurrent>
        <app-about-el
          [el]="getCurrentItem(currentIndex)"
        />
      </ng-template>
    </div>

    <div class="slide">
      <div class="slide-points" *ngIf="allItems.length > 1">
        <div *ngFor="let point of allItems; let i = index">
          <div class="point" [class.point-active]="i === nextIndex"></div>
        </div>
      </div>
      <ng-container *ngIf="slideType === 'locations'; else serviceSlideNext">
        <app-title-background
          [portal]="true"
          [button]="showButton"
          [countdown]="getPercent()"
          [locationDto]="getCurrentItem(nextIndex)"
          (emitClick)="clickOn()"
        />
      </ng-container>
      <ng-template #serviceSlideNext>
        <app-about-el
          [el]="getCurrentItem(nextIndex)"
        />
      </ng-template>
    </div>
  </div>
</div>
